<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="icon">
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans"
        d="M 7 4 C 4.2545455 4 2 6.2545455 2 9 L 2 33 C 2 35.745455 4.2545455 38 7 38 L 11.09375 38 C 11.230389 39.204771 11.215056 40.315003 10.90625 41.25 C 10.527079 42.398046 9.8220562 43.363016 8.5 44.15625 A 1.0001 1.0001 0 0 0 9 46 C 13.243507 46 18.10627 43.785512 20.5625 38 L 43 38 C 45.745455 38 48 35.745455 48 33 L 48 9 C 48 6.2545455 45.745455 4 43 4 L 7 4 z M 7 6 L 43 6 C 44.654545 6 46 7.3454545 46 9 L 46 33 C 46 34.654545 44.654545 36 43 36 L 20 36 A 1.0001 1.0001 0 0 0 19.0625 36.65625 C 17.507274 40.897777 14.731078 42.917893 11.84375 43.65625 C 12.235406 43.095806 12.603914 42.506551 12.8125 41.875 C 13.333329 40.298046 13.288467 38.570944 12.96875 36.8125 A 1.0001 1.0001 0 0 0 12 36 L 7 36 C 5.3454545 36 4 34.654545 4 33 L 4 9 C 4 7.3454545 5.3454545 6 7 6 z"
        overflow="visible"
        enable-background="accumulate"
        font-family="Bitstream Vera Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "comment-outline"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
